import React from "react";
import { generateCRUDRoutes } from "../../../../utils/index";

import { FaHeadset } from "react-icons/fa6";
import FAQs from "./index";

const faqRoutes = [	
    generateCRUDRoutes({
        mainTitle: "FAQs",
        basePath: "faq",
        mainComponent: <FAQs />,
        layout: "/console",	   
        icon: <FaHeadset className="icon-item" />,
        subTitle:"FAQ",
        level:5,
        moduleId: 0,
    })
]

export default faqRoutes;